import { useEffect, useState } from "react";

/* ─────────────────────────────────────────────
   IMAGE IMPORTS — src/assets/images/blogs/
───────────────────────────────────────────── */
import HeroImg             from "../../assets/images/blogs/tesla-india.webp";
import HeroImgMobile from "../../assets/images/blogs/tesla-india-mobile.webp";
import NewsletterBgDesktop from "../../assets/images/blogs/newsletter-bg.webp";
import NewsletterMicMobile   from "../../assets/images/blogs/newsletter-bg-mobile.webp";

/* Tweet screenshot images — imported directly, no coded component */
import TweetAvinash   from "../../assets/images/blogs/tweet-avinash-elon.webp";
import TweetElonGovt  from "../../assets/images/blogs/tweet-elon-govt-india.webp";
import TweetArvind    from "../../assets/images/blogs/tweet-arvind-elon.webp";

/* ─────────────────────────────────────────────
   WhatHappenedWithTeslaIndia.jsx
   Prefix      : bd-
   Fonts       : Montserrat (headings) | Roboto (body)
   Purple      : #743FAC
   BG main     : #1A1A1A
   BG dark     : #000000
   Max-W       : 1600px  |  Pad: 221px
   Content-W   : 980px
   Breaks      : 768px   |  480px
   Anim        : IntersectionObserver fade-up
                 delays 0.08s / 0.18s / 0.28s / 0.38s
─────────────────────────────────────────────── */

const CSS = `
  @import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@400;500;600;700;800;900&family=Roboto:wght@300;400;500;700&display=swap');

  .bd-wrap *, .bd-wrap *::before, .bd-wrap *::after {
    box-sizing: border-box;
    margin: 0;
    padding: 0;
  }
  .bd-wrap {
    font-family: 'Roboto', sans-serif;
    background: #1A1A1A;
    color: #ffffff;
    width: 100%;
    overflow-x: hidden;
  }
  .bd-inner {
    max-width: 1600px;
    margin: 0 auto;
    padding-left: 102px;
    padding-right: 102px;
    width: 100%;
  }
  .bd-content-col {
    
    width: 100%;
  }

  /* ── SCROLL FADE-UP ── */
  .bd-fade-up {
    opacity: 0;
    transform: translateY(40px);
    transition: opacity 0.7s ease, transform 0.7s ease;
  }
  .bd-fade-up.bd-in { opacity: 1; transform: translateY(0); }
  .bd-delay-1 { transition-delay: 0.08s; }
  .bd-delay-2 { transition-delay: 0.18s; }
  .bd-delay-3 { transition-delay: 0.28s; }
  .bd-delay-4 { transition-delay: 0.38s; }

  /* ══════════════════════════════════════
     HERO — black title bar + full img
  ══════════════════════════════════════ */
  .bd-hero { width: 100%; background: #000000; }
  .bd-hero__title-bar {
    width: 100%;
    background: #1A1A1A;
    padding: 60px 0px;
    
  }
  .bd-hero__title {
    font-family: 'Montserrat', sans-serif;
    font-size: 50px;
    font-weight: 700;
    color: #ffffff;
    line-height: 140%;
    text-align:center;
   
    
  }
  .bd-hero__img-wrap {
    width: 100%;
    max-height: 600px;
    overflow: hidden;
  }
  .bd-hero__img-wrap img {
    width: 100%;
    height: 100%;
    max-height: 600px;
    object-fit: cover;
    object-position: center;
    display: block;
  }

  /* ══════════════════════════════════════
     BODY CONTENT
  ══════════════════════════════════════ */
  .bd-body-section {
    width: 100%;
    background: #1A1A1A;
    padding: 60px 0 100px;
  }
  .bd-para {
    font-family: 'Roboto', sans-serif;
    font-size: 16px;
    font-weight: 400;
    line-height: 160%;
    color: #E2E2E2;
    margin-bottom: 24px;
  }
    
  .bd-subhead {
    font-family: 'Roboto', sans-serif;
    font-size: 20px;
    font-weight: 500;
    color: #ffffff;
    line-height: 160%;
    margin-bottom: 14px;
    margin-top:44px;
  }

  /* ══════════════════════════════════════
     TWEET IMAGE — direct screenshot embed
  ══════════════════════════════════════ */
  .bd-tweet-img-wrap {
    margin: 44px 0;
    max-width: 683px;
  }
  .bd-tweet-img-wrap img {
    width: 100%;
    height: auto;
    display: block;
    border-radius: 12px;
  }

  /* ══════════════════════════════════════
     NEWSLETTER
  ══════════════════════════════════════ */
  .bd-newsletter {
    width: 100%;
    position: relative;
    overflow: hidden;
    min-height: 500px;
    display: flex;
    align-items: center;
    
  }
  .bd-newsletter__bg {
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
    object-fit: conatin;
    object-position: center;
    z-index: 0;
    // filter: brightness(0.4);
  }
  .bd-newsletter__overlay {
    position: absolute;
    inset: 0;
    // background: linear-gradient(
    //   90deg,
    //   rgba(10,8,25,0.95) 0%,
    //   rgba(15,10,40,0.80) 55%,
    //   rgba(10,8,20,0.25) 100%
    // );
    z-index: 1;
  }
  .bd-newsletter__inner {
    position: relative;
    z-index: 2;
    width: 100%;
    max-width: 1600px;
    margin: 0 auto;
    padding: 0px 102px;
  }
  .bd-newsletter__heading {
    font-family: 'Montserrat', sans-serif;
    font-size: 50px;
    font-weight: 700;
    color: #ffffff;
    line-height: 120%;
    margin-bottom: 14px;
  }
  .bd-newsletter__sub {
    font-family: 'Roboto', sans-serif;
    font-size: 15px;
    color: rgba(255,255,255,0.72);
    line-height: 160%;
    margin-bottom: 24px;
  }
  .bd-newsletter__form {
    display: flex;
    align-items: stretch;
    max-width: 552px;
    gap:14px;
  }
  .bd-newsletter__input {
    flex: 1;
    height: 48px;
    background: #1A1A1A;
    border: 1px solid #ffffff;
    border-radius: 5px;
    padding: 15px 14px;
    font-family: 'Roboto', sans-serif;
    font-size: 16px;
    color: #FFFFFF;
    outline: none;
  }
  .bd-newsletter__input::placeholder { color: #FFFFFF; }
  .bd-newsletter__btn {
    height: 50px;
    padding: 15px 30px;
    background: #743FAC;
    border: none;
    border-radius:  5px;
    font-family: 'Roboto', sans-serif;
    font-size: 16px;
    font-weight: 500;
    color: #ffffff;
    cursor: pointer;
    display: inline-flex;
    align-items: center;
    gap: 8px;
    white-space: nowrap;
    transition: background 0.25s ease;
  }
  .bd-newsletter__btn:hover { background: #5e2e90; }
  .bd-newsletter__btn-arrow {
    display: inline-flex;
    align-items: center;
    transition: transform 0.2s ease;
  }
  .bd-newsletter__btn:hover .bd-newsletter__btn-arrow { transform: translateX(4px); }

  /* ══════════════════════════
     RESPONSIVE 768px
  ══════════════════════════ */
  @media (max-width: 768px) {
    .bd-inner { padding-left: 32px; padding-right: 32px; }
    .bd-hero__img-wrap img  { max-height: 350px;}
    .bd-hero__title-bar { padding: 24px 32px 20px; }
    .bd-hero__title { font-size: 24px; }
    .bd-body-section { padding: 40px 0 48px; }
.bd-para { margin-bottom: 18px;     font-size: 15px;}
    .bd-subhead { font-size: 18px; margin-top: 28px; margin-bottom:10px; }
    .bd-tweet-img-wrap { max-width: 450px;;margin: 28px 0; }

    /* mobile newsletter — bg is top half mic, bottom form */
     .bd-newsletter {
    min-height: auto;
    align-items: stretch;
    flex-direction: column;
    background: #1A1A1A;
  }
    .bd-newsletter__mic-img { width: 100%; height: 350px; object-fit: cover; }
  .bd-newsletter__inner {
    padding: 0;
    display: flex;
    flex-direction: column;
  }
  .bd-newsletter__content {
    padding: 40px 24px 48px;
    text-align: center;
  }
  .bd-newsletter__heading { font-size: 24px; }
  .bd-newsletter__sub { font-size: 14px; }
  .bd-newsletter__form {
    flex-direction: column;
    max-width: 100%;
    gap: 12px;
  }
  .bd-newsletter__input { border-radius: 5px; height: 44px; }
  .bd-newsletter__btn {
    border-radius: 5px;
    justify-content: center;
    height: 44px;
  }
  }

  /* ══════════════════════════
     RESPONSIVE 480px
  ══════════════════════════ */
  @media (max-width: 480px) {
    .bd-inner { padding-left: 16px; padding-right: 16px; }
    .bd-hero__title-bar { padding: 30px 16px; }
        .bd-body-section {padding: 30px 0 30px;}
        .bd-hero__img-wrap img {  max-height: 366px; width:100%;border-radius:none;}
    .bd-hero__title { font-size: 30px; line-height:120%; }
    .bd-para { font-size: 14px;margin-bottom: 14px; }
    .bd-tweet-img-wrap { margin: 30px 0; max-width:100%;}
        .bd-subhead { margin-top: 30px; margin-bottom:14px; font-size: 16px;}
    .bd-newsletter__inner { padding: 24px 16px 40px; }
    .bd-newsletter__heading { font-size: 30px;line-height:120%; }
    .bd-newsletter {
  min-height: auto;
    align-items: stretch;
    flex-direction: column;
    background: #1A1A1A;
  }
     .bd-newsletter__mic-img { width: 100%;height: 366px;}
  .bd-newsletter__inner {
    padding: 0;
    display: flex;
    flex-direction: column;
  }
  .bd-newsletter__content { 
    padding: 30px 16px 40px;
    text-align: center;
  }
  .bd-newsletter__mic-img {
    width: 100%;
    height: auto;
    display: block;
    object-fit: cover;
  }
  .bd-newsletter__heading { font-size: 22px; }
  .bd-newsletter__sub { font-size: 14px; max-width:275px; margin: 0 auto; }
  .bd-newsletter__form {
    flex-direction: column;
    max-width: 100%;
    gap: 15px;
    margin-top:15px;
  }
  .bd-newsletter__input { border-radius: 5px; height: 40px; font-size: 14px; }
  .bd-newsletter__btn {
    border-radius: 5px;
    justify-content: center;
    height: 40px;
    font-size: 14px;
  }
  }
`;

/* ── SCROLL REVEAL ── */
function useScrollReveal() {
  useEffect(() => {
    const els = document.querySelectorAll(".bd-fade-up");
    const obs = new IntersectionObserver(
      (entries) => entries.forEach((e) => { if (e.isIntersecting) e.target.classList.add("bd-in"); }),
      { threshold: 0.12 }
    );
    els.forEach((el) => obs.observe(el));
    return () => obs.disconnect();
  }, []);
}

/* ── ARROW ── */
function ArrowRight() {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
      <path d="M3 8h10M9 4l4 4-4 4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  );
}

function Newsletter() {
  const [email, setEmail] = useState("");
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const mq = window.matchMedia("(max-width: 768px)");
    setIsMobile(mq.matches);
    const handler = (e) => setIsMobile(e.matches);
    mq.addEventListener("change", handler);
    return () => mq.removeEventListener("change", handler);
  }, []);

  return (
    <section className="bd-newsletter">
      {/* desktop: full bg image with mic */}
      {!isMobile && (
        <>
          <img className="bd-newsletter__bg" src={NewsletterBgDesktop} alt="" aria-hidden="true" />
          <div className="bd-newsletter__overlay" />
        </>
      )}

      <div className="bd-newsletter__inner">
        {/* mobile/tab: mic as regular stacked image on top */}
        {isMobile && (
          <img
            className="bd-newsletter__mic-img"
            src={NewsletterMicMobile}
            alt="Microphone"
          />
        )}
        <div className="bd-newsletter__content">
          <h2 className="bd-newsletter__heading">Sign up for our<br />newsletter!</h2>
          <p className="bd-newsletter__sub">Get notified about updates and be the first to get early access to new episodes.</p>
          <div className="bd-newsletter__form">
            <input
              className="bd-newsletter__input"
              type="email"
              placeholder="Email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
            <button className="bd-newsletter__btn">
              Send
              <span className="bd-newsletter__btn-arrow"><ArrowRight /></span>
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}

/* ── ROOT EXPORT ── */
export default function WhatHappenedWithTeslaIndia() {
  useScrollReveal();
  const [isMobile, setIsMobile] = useState(false);
  useEffect(() => {
    const mq = window.matchMedia("(max-width: 480px)");
    setIsMobile(mq.matches);
    const handler = (e) => setIsMobile(e.matches);
    mq.addEventListener("change", handler);
    return () => mq.removeEventListener("change", handler);
  }, []);

  return (
    <>
      <style>{CSS}</style>
      <div className="bd-wrap">

        {/* HERO */}
<section className="bd-hero">
  <div className="bd-hero__title-bar">
    <h1 className="bd-hero__title">What Happened With Tesla India?</h1>
  </div>
  <div className="bd-hero__img-wrap">
    <img
      src={isMobile ? HeroImgMobile : HeroImg}
      alt="Tesla India"
    />
  </div>
</section>

        {/* BODY */}
        <section className="bd-body-section">
          <div className="bd-inner">
            <div className="bd-content-col">

              <p className="bd-para bd-fade-up bd-delay-1">That distant buzz is the sound of the race to electrification, which is changing for the better. But what about the participants who desire to enter the race but face a roadblock?</p>

              <p className="bd-para bd-fade-up bd-delay-1">India is one of the world's major automotive markets and has long been a market of interest for global car manufacturers looking to launch their EVs and capitalize on the massive opportunity. In order to promote the Make in India program, the government is seeking these corporations to build up manufacturing/assembly operations here. Nonetheless, despite the government's lofty ambitions, EV adoption in the Indian market is still waiting for that inflection point for 4-wheelers. Many significant players, including Tesla, Hyundai, Audi, etc have targeted the Indian market to make an entry in their electrification push. Whilst Hyundai &amp; Audi have already launched their EVs, Tesla seems to have some trouble.</p>

              <p className="bd-para bd-fade-up bd-delay-1">Tesla was already planning to enter the Indian market and had established its Indian subsidiary, Tesla India Motors and Energy Pvt. Ltd. But the Central Government strongly declared that the automotive giant must not 'import cars from China.' When asked on Twitter by Musk when Tesla automobiles will be accessible in the nation, Musk has often cited India's hefty vehicle import charges as the main reason Tesla chose Indonesia over India to establish its new production facility. While campaigning for a 40% drop in EV customs charges.</p>

              {/* Tweet 1 — screenshot image */}
              <div className="bd-tweet-img-wrap bd-fade-up bd-delay-2">
                <img src={TweetAvinash} alt="Tweet - Avinash Singh and Elon Musk" />
              </div>

              <h2 className="bd-subhead bd-fade-up bd-delay-1">What was the government offering to Tesla?</h2>

              <p className="bd-para bd-fade-up bd-delay-1">The government, for its part, has frequently pushed Elon Musk and Tesla to relocate production to India to benefit from government initiatives and avoid paying import charges. Furthermore, the government established a production-linked incentive plan (PLI scheme) to encourage the development of advanced chemistry cells (ACCs) in India. Ten companies, including Reliance, Hyundai, and Ola Electric, have participated in the project, which is valued at INR 18,100 Cr. Tesla was also supposed to join in the plan, but it did not.</p>

              <p className="bd-para bd-fade-up bd-delay-1">The Karnataka government welcomed Musk with open arms in January 2022 to begin Tesla's electric vehicle production efforts in India. Karnataka Minister C.N Ashwath Narayan commented that Tesla has already established a research and development unit in Bengaluru in January of last year. "Whenever Elon Musk is ready to establish a production unit in India, Karnataka would be delighted and eager to provide him our entire cooperation and assistance." Similarly, Telangana minister K.T.Rama Rao responded to Musk, saying, "Will be pleased to cooperate with Tesla in working through the difficulties to build a factory in India/Telangana." Ministers from Maharashtra, Punjab, West Bengal, and Tamil Nadu, in addition to Karnataka and Telangana, have encouraged Musk to establish Tesla facilities in their respective states.</p>

              <p className="bd-para bd-fade-up bd-delay-1">However, Tesla has repeatedly requested that the government reduce the import tariff on its electric vehicles before entering the Indian market, and he has called Prime Minister Narendra Modi's office with the request as the company prepares to sell its automobiles. However, several Indian automakers objected to the proposal, and the government issued a definitive comment on it, "If Tesla joins 'Make in India', the government will lower import duty."</p>

              {/* Tweet 2 — screenshot image */}
              <div className="bd-tweet-img-wrap bd-fade-up bd-delay-2">
                <img src={TweetElonGovt} alt="Tweet - Elon Musk on Indian government discussions" />
              </div>

              <h2 className="bd-subhead bd-fade-up bd-delay-1">Ultimately, Tesla's decision for the Indian EV market</h2>

              <p className="bd-para bd-fade-up bd-delay-1">Musk told a Twitter user that he was awaiting Indian government approval for importing the vehicles with lower import duties first. In addition to rejecting the concept of entering the EV industry, citing a sales barrier. Tesla supporters in India were in for a rocky ride when CEO Elon Musk revealed that his business will no longer produce electric automobiles in the country. Tesla CEO Elon Musk declared on May 28 that his company will not produce electric cars in India unless it is first authorized to sell and repair them locally.</p>

              <h2 className="bd-subhead bd-fade-up bd-delay-1">Tesla's take on the failure of entering India's EV space</h2>

              <p className="bd-para bd-fade-up bd-delay-1">Musk was aiming to establish Tesla facilities in India or Indonesia to expand his Asian footprint. For instance, China, the world's largest automobile market, has levied a 15% tax on imported cars since July 2018, down from a 25% tariff imposed during the US-China trade war in June 2018. As Chinese President Xi Jinping and then-US President Donald Trump levied retaliatory tariffs on each other's goods, the import taxes were lowered following amicable negotiations between the two nations. Hence, the Chinese government said on May 31, 2022, that taxes on automobiles costing less than ¥300,000 ($45,000) will be reduced to 5% beginning June 1, 2022, alleviating taxation concerns for Tesla and other major automotive manufacturers such as Volkswagen and Nissan.</p>

              <p className="bd-para bd-fade-up bd-delay-1">Similarly, in Indonesia, where Tesla is considering establishing a factory, the government has proposed a zero-percentage-point duty on imported electric vehicles in order to strengthen the country's battery-based electric motor vehicle program for road transportation. The majority of Tesla India's staff has traveled to Dubai and is focused on Middle Eastern markets.</p>

              <p className="bd-para bd-fade-up bd-delay-1">It was seen that Audi India had joined Tesla and Hyundai India in calling for a reduction in electric car import duties (EVs). Following the debut of two electric vehicles in India, the e-Tron GT and the RS e-Tron GT, priced at Rs 1.79 crore and Rs 2.04 crore, respectively (ex-showroom). Balbir Singh Dhillon, the CEO of Audi India, appears to be seeking that the government grants a window of 3-5 years of lower import taxes (for EVs) until sales rise enough for carmakers to justify producing such vehicles in India. When asked how much import duty should be decreased, Dhillon stated that a figure close to 40% will help the segment. Similarly, Hyundai noted that government assistance in the form of levies and the building of countrywide charging infrastructure were the two most essential causes for the growth of the EV business in India.</p>

              {/* Tweet 3 — screenshot image */}
              <div className="bd-tweet-img-wrap bd-fade-up bd-delay-2">
                <img src={TweetArvind} alt="Tweet - Arvind Gupta and Elon Musk exchange" />
              </div>

              <p className="bd-para bd-fade-up bd-delay-1">The global market shift from ICE to EV is largely driven by the global climate agenda outlined in the Paris Agreement under UNFCCC, which aims to cut carbon emissions to battle the grave issue of global warming. Which Indian Government has been taking continuous steps to develop and promote the EV ecosystem in the country since 2012. India's drive for E-mobility programs has encouraged numerous existing vehicle manufacturers and new entrants to begin building e-vehicles in the passenger, last mile connectivity, and bulk short/long distance transportation arena. This is when the notion of importing their automobile to India came into play. The juice in the story is that the government proposed producing these cars locally and in India, as part of the 'Make in India' initiative.</p>

              <p className="bd-para bd-fade-up bd-delay-1">To that objective, 14 of India's 28 states have finished or are in the process of completing EV policies that complement national electric mobility regulations. Among the states that have supported EV policies are Andhra Pradesh, Karnataka, Kerala, Madhya Pradesh, Maharashtra, New Delhi, Tamil Nadu, Telangana, Uttarakhand, and Uttar Pradesh, as well as others with drafting plans. Almost all state EV policies emphasize two- and three-wheelers, public transit, and job growth. Here is where the commotion began, when the government emphasized the import policy for these automobiles. According to the import regulation, 'Automobiles imported into India are now taxed at a 60% import charge on fully imported cars costing $40,000 or less, and a 100% levy on vehicles costing more than $40,000.'</p>

              <p className="bd-para bd-fade-up bd-delay-1">Musk's earlier promise that he will begin selling in India by 2021 has flopped. Tesla spent the whole last year pressing the Indian government to reduce import taxes on their EVs. Manuj Khurana, a policy and business development officer, was employed by the automaker's India subsidiary in March of last year. After months of an impasse over an import tax rate of up to 100%, Musk acknowledged in a tweet last month that he did not agree with the Indian government's demand that the automaker commits to producing its EVs locally to qualify for tax breaks. On June 15th, Khurana, Tesla India's first employee, quit, thereby putting an end to the company's prospects in India.</p>

              <p className="bd-para bd-fade-up bd-delay-1">Despite the government's attempts to expand the ecosystem as quickly as possible in a developing country like India, electric vehicles and charging infrastructure are still in their early stages. Thereby, the premise that we would create a market by exporting finished goods to India is out of date, and we must move on. To increase the acceptance and affordability of electric vehicles, efforts should be made to create goods and components in India rather than rely on subsidized imports.</p>

            </div>
          </div>
        </section>

        {/* NEWSLETTER */}
        <Newsletter />

      </div>
    </>
  );
}